import type { TtqibState } from './types';
import { normalizeTtqibState } from './ttqibStateMigrate';
import type { TtqSession } from '../../services/ttqService';

const STORAGE_KEY_PREFIX = 'ttqib:state:';

type StoredPayload = Partial<TtqibState> & {
  excalidrawScene?: unknown;
  nodes?: TtqibState['nodes'];
};

export function loadLocalTtqibState(sessionId: string, session?: TtqSession | null): TtqibState | null {
  try {
    const key = `${STORAGE_KEY_PREFIX}${sessionId}`;
    const raw = localStorage.getItem(key);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as StoredPayload;
    if (!session) {
      return parsed as TtqibState;
    }
    return normalizeTtqibState(session, parsed);
  } catch {
    return null;
  }
}

export function saveLocalTtqibState(sessionId: string, state: TtqibState): void {
  try {
    const key = `${STORAGE_KEY_PREFIX}${sessionId}`;
    const payload: TtqibState = {
      ...state,
      nodes: undefined,
    };
    localStorage.setItem(key, JSON.stringify(payload));
  } catch (error) {
    console.warn('[ttqib] failed to save state', error);
  }
}

export function clearLocalTtqibState(sessionId: string): void {
  try {
    const key = `${STORAGE_KEY_PREFIX}${sessionId}`;
    localStorage.removeItem(key);
  } catch (error) {
    console.warn('[ttqib] failed to clear state', error);
  }
}
